var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { ref: "commendFeedRef", attrs: { "data-spm": "feed" } }, [
    _vm.topList.length
      ? _c("div", { attrs: { id: "topFeed" } }, [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "feed-content",
              attrs: { "data-solt": "topFeedContent" },
            },
            [
              _vm._l(_vm.topList, function (item, index) {
                return [
                  item.type == 3
                    ? _c("TripleImgs", {
                        key: index,
                        attrs: { feedData: item },
                      })
                    : item.images && item.images.length > 0
                    ? _c("SimgleImg", { key: index, attrs: { feedData: item } })
                    : _c("NoImg", { key: index, attrs: { feedData: item } }),
                ]
              }),
            ],
            2
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { attrs: { id: "recentFeed" } }, [
      _vm._m(1),
      _vm._v(" "),
      _c("div", { staticClass: "feed-content" }, [
        _c(
          "div",
          { attrs: { "data-solt": "recentFeedContent" } },
          [
            _vm._l(_vm.list, function (item, index) {
              return [
                item.type == 3
                  ? _c("TripleImgs", { key: index, attrs: { feedData: item } })
                  : item.images && item.images.length > 0
                  ? _c("SimgleImg", { key: index, attrs: { feedData: item } })
                  : _c("NoImg", { key: index, attrs: { feedData: item } }),
              ]
            }),
          ],
          2
        ),
        _vm._v(" "),
        _c("div", { staticClass: "list-status" }, [
          _vm.isFinish
            ? _c(
                "div",
                { staticClass: "more-load", attrs: { "data-role": "empty" } },
                [_vm._v("已经到底了")]
              )
            : _vm._e(),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "feed-header" }, [
      _c("span", { staticClass: "feed-header__title" }, [_vm._v("置顶文章")]),
      _vm._v(" "),
      _c("hr", { staticClass: "fake-hr" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "feed-header" }, [
      _c("span", { staticClass: "feed-header__title" }, [_vm._v("最新文章")]),
      _vm._v(" "),
      _c("hr", { staticClass: "fake-hr" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }